import { AnimatedNumber } from 'ui/atoms/AnimatedNumber/AnimatedNumber';
import { Section } from 'ui/molecules/Section/Section';

import styles from './PricingQuoteHero.module.scss';

const STATS = [
  { value: 600, suffix: 'M+', label: 'companies' },
  { value: 400, suffix: '+', label: 'official registries' },
];

export const PricingQuoteHero = () => (
  <Section
    theme="dark"
    layout="split"
    splitWideLeft
    titleSize="page"
    title="Choose the data you need. Get a quote in one step."
    description="Priced on the data, markets and volume you use - not seats. Unlimited users on every corporate plan."
    className={styles.hero}
  >
    <div className={styles.stats}>
      {STATS.map((stat) => (
        <div className={styles.stat} key={stat.label}>
          <AnimatedNumber value={stat.value} suffix={stat.suffix} className={styles.statValue} />
          <span className={styles.statLabel}>{stat.label}</span>
        </div>
      ))}
    </div>
  </Section>
);
